/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem, SortableArrayField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { postBy, formatArticleError } from '@utils';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

import { FORM_FIELD } from './constants';

const VideoItem = ({ video }) => {
  const { media } = useMedia(getImage(video, 'featureImage'));

  if (video instanceof Error) {
    const error = video;
    return <InfoItem>{formatArticleError(error)}</InfoItem>;
  }

  return (
    <InfoItem image={media.src} description={postBy(video)}>
      {video.title}
    </InfoItem>
  );
};

const VideoList = ({ form }) => {
  return (
    <SortableArrayField {...FORM_FIELD.VIDEOS} style={NO_MARGIN_BOTTOM} form={form} withPlaceholder withCount>
      {(video) => video && <VideoItem video={video} />}
    </SortableArrayField>
  );
};

export default VideoList;
